<template>
  <section class="share">
    <div class="divul">
      <div
        class="divli"
        v-for="item in shareList"
        :key="item.id"
        @click="shareTo(item)"
      >
        <el-popover
          placement="bottom"
          v-model="visible"
          v-if="item.id === 3"
          trigger="hover"
        >
          <div class="qrCodeBox"><div id="qrcode"></div></div>
          <img
            slot="reference"
            style="with: 26px; height: 26px"
            :src="item.icon"
            @mouseenter="mouseenter(item)"
            @mouseleave="mouseleave(item)"
            :title="language === 'zh' ? item.title : item.enTitle"
          />
        </el-popover>
        <img
          :src="item.icon"
          @mouseenter="mouseenter(item)"
          @mouseleave="mouseleave(item)"
          alt
          :title="language === 'zh' ? item.title : item.enTitle"
          v-else
        />
      </div>
    </div>
  </section>
</template>


<script>
import QRCode from "qrcodejs2";
export default {
  props: ["config", "type"],
  components: { QRCode },
  data() {
    return {
      visible: false,
      shareList: [
        {
          icon: "/static/v2/match/share_weibo.png",
          icon_hover: "/static/v2/match/share_weibo_hover.png",
          title: "微博",
          enTitle: "weibo",
          id: 1,
        },
        {
          icon: "/static/v2/match/share_qq.png",
          icon_hover: "/static/v2/match/share_qq_hover.png",
          title: "QQ",
          enTitle: "QQ",
          id: 2,
        },
        {
          icon: "/static/v2/match/share_wechat.png",
          icon_hover: "/static/v2/match/share_wechat_hover.png",
          title: "微信",
          enTitle: "wechat",
          id: 3,
        },
        {
          icon: "/static/v2/match/share_twitter.png",
          icon_hover: "/static/v2/match/share_twitter_hover.png",
          title: "推特",
          enTitle: "Twitter",
          id: 4,
        },
        {
          icon: "/static/v2/match/share_fb.png",
          icon_hover: "/static/v2/match/share_fb_hover.png",
          title: "Facebook",
          enTitle: "Facebook",
          id: 5,
        },
      ],
      qrcode: null,
    };
  },
  computed: {
    language() {
      return this.$language();
    },
  },
  watch: {
    "config.share_url"(value) {
      this.qrcode.makeCode(value);
    },
    deep: true,
  },
  created() {
    this.$nextTick(() => {
      this.makeQrcode();
    });
    if (this.type && this.type == 1) {
      this.shareList = [
        {
          icon: "/static/video/fin_share_weibo_hover@2x.png",
          icon_hover: "/static/v2/match/share_weibo_hover.png",
          title: "微博",
          enTitle: "weibo",
          id: 1,
        },
        {
          icon: "/static/video/fin_share_qq_hover@2x.png",
          icon_hover: "/static/v2/match/share_qq_hover.png",
          title: "QQ",
          enTitle: "QQ",
          id: 2,
        },
        {
          icon: "/static/video/fin_share_wechat_hover@2x.png",
          icon_hover: "/static/v2/match/share_wechat_hover.png",
          title: "微信",
          enTitle: "wechat",
          id: 3,
        },
        {
          icon: "/static/video/fin_share_twitter_hover@2x.png",
          icon_hover: "/static/v2/match/share_twitter_hover.png",
          title: "推特",
          enTitle: "Twitter",
          id: 4,
        },
        {
          icon: "/static/video/fin_share_fb_hover@2x.png",
          icon_hover: "/static/v2/match/share_fb_hover.png",
          title: "Facebook",
          enTitle: "Facebook",
          id: 5,
        },
      ];
    }
  },
  methods: {
    shareTo(item) {
      switch (item.id) {
        case 1:
          this.shareToweibo(this.config);
          break;
        case 2:
          this.shareToQQ(this.config);
          break;
        case 4:
          this.shareTotuite(this.config);
          break;
        case 5:
          this.shareTofaceBook(this.config);
          break;
        default:
          break;
      }
    },
    shareToQQ(share) {
      window.open(
        `https://connect.qq.com/widget/shareqq/index.html?url=${encodeURIComponent(
          share.share_url
        )}&title=${encodeURIComponent(share.title)}&desc=${share.desc}&pics=${share.pics}`
      );
    },
    shareToweibo(share) {
      window.open(
        `https://service.weibo.com/share/share.php?url=${encodeURIComponent(
          share.share_url
        )}&title=${encodeURIComponent(share.title)}&pic=${share.pics}&searchPic=true`
      );
    },
    shareTotuite(share) {
      window.open(
        `https://twitter.com/intent/tweet?original_referer=${encodeURIComponent(
          share.share_url
        )}&url=${encodeURIComponent(share.share_url)}&text=${encodeURIComponent(share.title)}&pic=${
          share.pics
        }&searchPic=true`
      );
    },
    shareTofaceBook(share) {
      window.open(
        `https://www.facebook.com/sharer.php?u=${encodeURIComponent(
          share.share_url
        )}&title=${encodeURIComponent(share.title)}&pic=${share.pics}&searchPic=true`
      );
    },
    makeQrcode() {
      this.qrcode = new QRCode(document.querySelector("#qrcode"), {
        width: 150,
        height: 150, // 高度
        text: this.config.share_url, // 二维码内容
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    mouseenter(item) {
      event.target.src = item.icon_hover;
    },
    mouseleave(item) {
      event.target.src = item.icon;
    },
  },
};
</script>
<style lang="stylus" scoped>
.share {
  display: flex;

  .divul {
    display: flex;
    flex-direction: row;
    padding: 0 10px;
    margin-left: 50%;
    transform: translate(-50%);

    .divli {
      margin-right: 20px;
      cursor: pointer;
      position: relative;
      width: 26px;
      height: 26px;

      div {
        position: absolute;
      }

      &:last-child {
        margin-right: 0;
      }

      &>img {
        width: 26px;
        height: 26px;
      }
    }
  }
}

.qrCodeBox {
  padding: 0 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/v2/Share.vue